import { useContext } from "react"
import { AppContext } from "../App"
import { MdMenu } from "react-icons/md";
import logo from '../assets/logo_icon.png';

export default function TopBar(props) {

  const appContext = useContext(AppContext);

  function goTo(item) {
    appContext.navTo({
      item,
    })
  }

  return (
    <div className="TopBar">
      <div className="body">
        <div className="topbar-modern-shell">
          <div className="topbar-modern-brand" onClick={() => goTo("home")}>
            <img src={logo} alt="Kinemo Logo" width={100} className="topbar-modern-logo mDesktopOnly" />
            <img src={logo} alt="Kinemo Logo" width={100} className="topbar-modern-logo topbar-modern-logo-mobile mMobileOnly" />
          </div>

          

          <div className="topbar-modern-mobile-actions">
            <div className="topbar-modern-nav mDesktopOnly">
            <div
              className="topbar-modern-nav-item"
              data-active={appContext.navItem === "home"}
              onClick={() => goTo("home")}
            >
              Home
            </div>

            <div
              className="topbar-modern-nav-item"
              data-active={appContext.navItem === "about_us"}
              onClick={() => goTo("about_us")}
            >
              About Us
            </div>

            <div
              className="topbar-modern-nav-item"
              data-active={appContext.navItem === "services"}
              onClick={() => goTo("services")}
            >
              Services
            </div>

            
          </div>
            <button className="topbar-modern-cta mDesktopOnly" onClick={() => goTo("contact_us")}>
              Contact Us
            </button>
            <button className="topbar-modern-menu-btn  mMobileOnly" onClick={appContext.openSideBar} aria-label="Open menu">
              <MdMenu size={26} />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
